import React from 'react';
import PropTypes from 'prop-types';
import config from '../siteConfig';
import Pagination from '../components/Pagination';
import PostExcerptList from '../components/PostExcerptList';
import Seo from '../components/Seo';

export default function BlogPostPaginatedTemplate({ pathContext, location }) {
  const { posts, pageNumber, isFirstPage, isLastPage } = pathContext;
  const pagePath = location.pathname;

  return (
    <section className="site-page">
      <Seo pagePath={pagePath} />
      <header className="site-page--header">
        <h1 className="site-page--title" itemProp="headline">
          Blog
        </h1>
      </header>

      <PostExcerptList posts={posts} />

      <Pagination
        baseRoute={config.routePosts}
        isFirstPage={isFirstPage}
        isLastPage={isLastPage}
        previousRoute={pageNumber > 2 ? (pageNumber - 1).toString() : ''}
        nextRoute={(pageNumber + 1).toString()}
      />
    </section>
  );
}

BlogPostPaginatedTemplate.propTypes = {
  pathContext: PropTypes.shape({
    posts: PropTypes.object.isRequired,
    pageNumber: PropTypes.number.isRequired,
    isFirstPage: PropTypes.bool.isRequired,
    isLastPage: PropTypes.bool.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};



// WEBPACK FOOTER //
// ./src/templates/BlogListPaginatedTemplate.js